import { Button, Dialog } from '@ifood/pomodoro-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DialogFooter, DialogHeader, DialogHeading } from './styles';

type PropTypes = {
  children?: React.ReactNode;
  isOpen?: boolean;
  isLoading?: boolean;
  disableConfirm?: boolean;
  title?: React.ReactNode;
  onCloseClick?: () => void;
  onConfirmClick?: () => void;
  cancelIntlKey?: string;
  confirmIntlKey?: string;
};

const ConfirmationDialog = ({
  isOpen = false,
  isLoading,
  disableConfirm,
  children,
  title,
  onCloseClick,
  onConfirmClick,
  cancelIntlKey = 'cancel',
  confirmIntlKey = 'confirm',
}: PropTypes): JSX.Element => (
  <Dialog open={isOpen} onClose={onCloseClick}>
    <DialogHeader>
      <DialogHeading>{title}</DialogHeading>
    </DialogHeader>
    <Dialog.Body>{children}</Dialog.Body>
    <DialogFooter>
      <Button onClick={onCloseClick} variant="secondary">
        <FormattedMessage id={cancelIntlKey} />
      </Button>
      <Button ml={10} variant="primary" isLoading={isLoading} onClick={onConfirmClick} disabled={disableConfirm}>
        <FormattedMessage id={confirmIntlKey} />
      </Button>
    </DialogFooter>
  </Dialog>
);

export default ConfirmationDialog;
